module.exports = __webpack_public_path__ + "static/media/obstetrica.a6555029.svg";